import React, { FC } from 'react'
import { Button } from 'hljd'
import style from './style.module.less'
import { buyUltimate } from '@util'
/**
 *
 * @author  Ta_Mu
 * @date 2021/5/21 15:01
 */

const ConsultBtn: FC = () => {

  return (
    <Button type='primary' className={style.consultBtn} onClick={buyUltimate}>立即咨询</Button>
  )
}

export default ConsultBtn
